import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_BEGIN,
  ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_SUCCESS,
  ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_FAILURE,
  ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_DISMISS_ERROR,
} from './constants';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addCustomFontsInProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const URL = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-fonts`;
      const doRequest = axios.post(URL, args, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_SUCCESS,
            data: res.data.customFonts,
          });
          toast.success('Font Installed successfully');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Addition Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddCustomFontsInProjectError() {
  return {
    type: ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_BEGIN:
      return {
        ...state,
        addCustomFontsInProjectPending: true,
        addCustomFontsInProjectError: null,
      };

    case ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_SUCCESS:
      return {
        ...state,
        addCustomFontsInProjectPending: false,
        addCustomFontsInProjectError: null,
        customFontsList: action.data,
      };

    case ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_FAILURE:
      return {
        ...state,
        addCustomFontsInProjectPending: false,
        addCustomFontsInProjectError: action.data.error,
      };

    case ON_BOARDING_ADD_CUSTOM_FONTS_IN_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        addCustomFontsInProjectError: null,
      };

    default:
      return state;
  }
}
